export const aspects = {
	conjunction: {
		color: 'purple',
		keyword: 'sameness',
		description: 'With the moon being in the same sign, there’s a sense of familarity that’s hard to beat. Your inner needs are very similar, so similar it can be downright uncanny.',
	},
	trine: {
		color: 'blue',
		keyword: 'flow',
		description: 'Both moon signs share the same element (fire, earth, air, or water), which means that you might be similar enough to be harmonious, yet different enough to be exciting.'
	},
	sextile: {
		color: 'turquoise',
		keyword: 'growth',
		description: 'Here, both moon signs are different enough to allow each person to learn from the other. Opportunities for growth exist.'
	},
	quincunx: {
		color: 'green',
		keyword: 'uniqueness',
		description: 'Both moon signs are completely unique to each other. Appreciate each other’s uniqueness!'
	},
	semisextile: {
		color: 'yellow',
		keyword: 'difference',
		description: 'Differences prevail here. To find mutual ground, patience and respect for each other’s differences may be helpful.'
	},
	opposition: {
		color: 'orange',
		keyword: 'polarity',
		description: 'Opposites attract! That may lead to both fascination and frustration — balance may be necessary.'
	},
	square: {
		color: 'red',
		keyword: 'energy',
		description: 'A combination that’s rarely boring: each person’s needs are completely different and this can either be exciting or frustrating — or both.'
	}
}



// WEBPACK FOOTER //
// ./src/data/aspects.js